import get from 'lodash/get';
import moment from 'moment';
import { API_DATE_FORMAT, DATE_FORMAT } from '../../helpers/date';

moment.locale('ru');

const DEFAULT = 'default_answer';
const SHORT = 'short_answer';
const DETAILED = 'detailed_answer';
const SPEAKING_PART = 'speaking_part';
const SPEAKING_CRITERIAS = 'speaking_criterias';
const ESSAY = 'essay';

export const ANSWER_TYPES = {
  DEFAULT,
  SHORT,
  DETAILED,
  SPEAKING_PART,
  SPEAKING_CRITERIAS,
  ESSAY,
};

const capitalize = (string = '') => {
  if (string.length === 0) {
    return '';
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
};

/* маппинг группы типов ГВЭ */
const typeIsGve = (exam) => exam.type === 'gve9' || exam.type === 'gve11';

/* стандартное форматирование дат */
const formatDate = (date) => (date ? moment(date).format(DATE_FORMAT) : '');

const getPrescore = (exam) => {
  if (exam.prescore) {
    return exam.prescore;
  }

  if (typeIsGve(exam)) {
    return exam.score;
  }

  return null;
};

export const getConvertedExamType = (exam) => {
  const isGve = typeIsGve(exam);
  if (isGve) {
    return 'GVE_' + exam.type.trim().slice(3);
  }
  return exam.type.toUpperCase();
};

/**
 * мэппинг html-таблиц
 **/
const getGradesTable = (currentExam) => {
  const tables = get(currentExam, 'grades_table', []);

  if (tables.length !== 1) {
    return tables;
  }

  const blocks = tables[0].split('<tr class="type-title">').slice(1);
  const processedBlocks = blocks.map(
    (block) => '<table><tr class="type-title">' + block + '</table>',
  );

  return processedBlocks;
};

/* мапинг данных для выбора интервала онлайн-чата */
export const getIntervals = (params) => {
  const dates = Object.values(get(params, 'online_chat_dates', {}));

  return dates.reduce((accum, curDate) => {
    const intervals = curDate.intervals.map((item) => {
      const timeBegin = moment(item.start, 'HH.mm');
      const timeEnd = moment(item.end, 'HH.mm');

      return {
        value: {
          conv_day: curDate.value,
          conv_time_begin: timeBegin.format('HH:mm:ss[.0Z]'),
          conv_time_end: timeEnd.format('HH:mm:ss[.0Z]'),
        },
        text: `${capitalize(
          moment(curDate.value, API_DATE_FORMAT).format('dd[,] D MMMM[,]'),
        )} ${timeBegin.format('HH:mm')} – ${timeEnd.format('HH:mm')}`,
      };
    });

    return [...accum, ...intervals];
  }, []);
};

const examMapped = (data) => {
  // вытаскивает массив экзаменов из ответа сервера
  const exams = get(data, 'data.exams', []);

  return exams.map((exam) => {
    return {
      ...exam,
      examId: `${exam.date}_${exam.subject_code}`,
      // subjectName: exam.subject_name,
      // date: exam.date,
      // protocolDate: exam.protocol_date,
      // file: exam.file,
      // score: exam.score,
      prescore: getPrescore(exam),
      // minscore: exam.minscore,
      // type: exam.type,
      examApprove: false,
      grades_table: [],
      grades_table_raw: getGradesTable(exam),
      chatIntervals: getIntervals(exam),
      type_is_gve: typeIsGve(exam),
      date_formatted: formatDate(exam.date),
      protocol_date_formatted: formatDate(exam.protocol_date),
      appeal_end_date_formatted: formatDate(exam.appeal_end_date),
      appeal_start_date_formatted: formatDate(exam.appeal_start_date),
      appeal_end_date2_formatted: formatDate(exam.appeal_end_date2),
      appeal_start_date2_formatted: formatDate(exam.appeal_start_date2),
    };
  });
};
/* eslint-enable */

export default examMapped;
